import axios from "axios";
import { useContext, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { baseUrl } from "../../account/login";
import { AuthContext } from "../../../context/authContext";
import MyLoader from "../../../component/loader";

export default function PayStackRedirect() {
  const [searchParams] = useSearchParams();
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();
  useEffect(() => {
    const reference = searchParams.get("reference");
    axios
      .post(
        `${baseUrl}/payments/paystack/save_card`,
        {
          reference,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        if (response.data?.success) {
          navigate("/settings", {
            state: {
              from: "paystack",
              error: false,
              message: response.data?.message,
            },
          });
        } else {
          navigate("/settings", {
            state: {
              from: "paystack",
              error: true,
              message: response.data?.message,
            },
          });
        }
      })
      .catch((error) => {
        navigate("/settings", {
          state: {
            from: "paystack",
            error: true,
            message: error,
          },
        });
      });
  }, [searchParams]);

  return (
    <div className="h-screen w-full flex items-center justify-center">
      <MyLoader />
    </div>
  );
}
